<template>
  <v-expansion-panel
    v-if="
      settingsDevStore.canUseDevFeature('DEEPA_SUMMARIZE') &&
      AuthService.isAuthenticated
    "
  >
    <v-expansion-panel-title
      class="drawer-subhead"
      data-test-id="expansion-panel-summarize"
      static
    >
      {{ t('labels.summarized_document_content') }}
      <template #actions="{ expanded }">
        <VIcon :class="{ 'fa-rotate-180': expanded }" :size="12">
          far fa-chevron-down
        </VIcon>
      </template>
    </v-expansion-panel-title>
    <v-expansion-panel-text>
      <DeepASummarizeDocumentContent :document streamed />
    </v-expansion-panel-text>
  </v-expansion-panel>
</template>

<script setup lang="ts">
import AuthService from '@/services/authService.ts';
import DeepASummarizeDocumentContent from '@/components/deepa/DeepASummarizeDocumentContent.vue';
import { useI18n } from 'vue-i18n';
import type { PropType } from 'vue';
import type { Document } from '@/types/Document.ts';
import { useSettingsDevStore } from '@/stores/settingsDev.ts';

defineProps({
  document: {
    type: Object as PropType<Document>,
    default: undefined
  }
});

const { t } = useI18n();
const settingsDevStore = useSettingsDevStore();
</script>
